import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { BookmarkSimple, X } from '@phosphor-icons/react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const auth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } });

// Saved message templates (per account). Rendered on desktop only by the caller.
export const TemplatePicker = ({ currentMessage, onPick }) => {
  const [templates, setTemplates] = useState([]);
  const [naming, setNaming] = useState(false);
  const [name, setName] = useState('');

  useEffect(() => {
    axios.get(`${API}/message-templates`, auth()).then((r) => setTemplates(r.data || [])).catch(() => {});
  }, []);

  const save = async () => {
    try {
      const { data } = await axios.post(`${API}/message-templates`, { name, body: currentMessage }, auth());
      setTemplates((prev) => [...prev, data]);
      setNaming(false);
      setName('');
      toast.success('Template saved');
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Could not save the template.');
    }
  };

  const remove = async (id) => {
    try {
      await axios.delete(`${API}/message-templates/${id}`, auth());
      setTemplates((prev) => prev.filter((x) => x.id !== id));
    } catch {
      toast.error('Could not delete the template.');
    }
  };

  return (
    <div className="flex flex-wrap items-center gap-1.5" data-testid="message-template-picker">
      {templates.map((tpl) => (
        <span key={tpl.id} className="group inline-flex items-center rounded-full border border-indigo-200 bg-indigo-50 text-xs text-indigo-800">
          <button type="button" onClick={() => onPick(tpl.body)} className="pl-3 pr-1 py-1 hover:text-indigo-950" data-testid={`message-template-${tpl.id}`}>{tpl.name}</button>
          <button type="button" onClick={() => remove(tpl.id)} aria-label={`Delete ${tpl.name}`} className="pr-2 pl-0.5 py-1 opacity-40 group-hover:opacity-100" data-testid={`message-template-delete-${tpl.id}`}>
            <X size={10} weight="bold" />
          </button>
        </span>
      ))}
      {naming ? (
        <span className="inline-flex items-center gap-1">
          <input
            autoFocus
            value={name}
            maxLength={40}
            onChange={(e) => setName(e.target.value)}
            onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); if (name.trim()) save(); } if (e.key === 'Escape') setNaming(false); }}
            placeholder="Template name"
            className="h-7 w-36 rounded-full border border-gray-300 px-3 text-xs"
            data-testid="message-template-name-input"
          />
          <button type="button" disabled={!name.trim()} onClick={save} className="h-7 rounded-full bg-indigo-600 px-3 text-xs font-medium text-white disabled:opacity-40" data-testid="message-template-save-confirm-btn">Save</button>
        </span>
      ) : (
        <button type="button" disabled={!currentMessage.trim()} onClick={() => setNaming(true)} className="inline-flex items-center gap-1 rounded-full px-2.5 py-1 text-xs font-medium text-gray-600 hover:bg-gray-100 disabled:opacity-40" data-testid="message-template-save-btn">
          <BookmarkSimple size={12} weight="bold" />Save as template
        </button>
      )}
    </div>
  );
};

export default TemplatePicker;
